import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/picross.json";
import fr from "@/locales/fr/puzzle-types/picross.json";

export const PICROSS_NS = "puzzle-types/picross";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerPicrossTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", PICROSS_NS))
    i18n.addResourceBundle("en", PICROSS_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", PICROSS_NS))
    i18n.addResourceBundle("fr", PICROSS_NS, fr, true, true);
}
